import { WizardStepsDataDescribed } from '@cs/components/wizard';
import { Result }                   from '@cs/core';
import { CsHttpRequestOptions }     from '@cs/core/http';
import { Observable }               from 'rxjs';

import { RequestStepDataEventArgs } from '../models/request-step-data-event-args';

/**
 * `TResult` is the payload type returned by `finishWizard` and consumed by
 * `finishSuccessHandler`. Each implementer declares it via the class-level generic, e.g.
 * `extends WizardConfigService<NewUserRequestWizardFinishResult>`. Defaults to `unknown`
 * for stubs and ad-hoc implementations that do not care about the payload shape.
 */
export abstract class WizardConfigService<TResult = unknown> {

	abstract getStepData(eventArgs: RequestStepDataEventArgs,  refreshContext?: {
		[key: string]: any
	}, errorHandler?: CsHttpRequestOptions): Observable<Result<WizardStepsDataDescribed>>;

	abstract finishWizard(eventArgs: RequestStepDataEventArgs, errorHandler?: CsHttpRequestOptions): Observable<Result<TResult>>;

	/**
	 * Invoked by the wizard component after `finishWizard` succeeds.
	 * Implementations own all post-success behavior (typically navigation) — the wizard
	 * component itself does not navigate.
	 */
	abstract finishSuccessHandler(result: Result<TResult>): void;

	abstract validateWizardSteps(stepContextData: RequestStepDataEventArgs, errorHandler?: CsHttpRequestOptions): Observable<Result<boolean>>;

	abstract updateWizardSteps(stepContextData: RequestStepDataEventArgs, errorHandler?: CsHttpRequestOptions): Observable<Result<WizardStepsDataDescribed>>;

	abstract getWizardSteps(errorHandler?: CsHttpRequestOptions): Observable<Result<WizardStepsDataDescribed>>;
}
